<template>
  <v-app-bar app color="#15092e" dark elevate-on-scroll>
    <div class="app-bar-content">
      <v-toolbar-title>
        <router-link to="/">
          <v-img class="logo-image" src="@/assets/images/Rectangle 3.png" alt="Logo" contain height="40"></v-img>
        </router-link>
      </v-toolbar-title>

      <div class="nav">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/" class="nav-button" v-bind="attrs" v-on="on">
              <img src="@/assets/images/home.png" alt="Home" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Home</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/comunidade" class="nav-button" v-bind="attrs" v-on="on">
              <img src="@/assets/images/comunidade.png" alt="Comunidade" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Comunidade</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/marketplace" class="nav-button" v-bind="attrs" v-on="on">
              <img src="@/assets/images/carrinho.png" alt="Marketplace" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Marketplace</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon to="/zinnes" class="nav-button nav-button--zinnes" v-bind="attrs" v-on="on">
              <img src="@/assets/images/zinnes.png" alt="Originais Zinnes" class="nav-icon-img" />
            </v-btn>
          </template>
          <span>Originais Zinnes</span>
        </v-tooltip>
      </div>

      <div class="container-btns">
        <div class="header-search">
          <form class="header-search__form" role="search" @submit.prevent="executeSearch">
            <v-icon class="header-search__icon">mdi-magnify</v-icon>
            <input
              v-model="searchQuery"
              class="header-search__input"
              type="search"
              autocomplete="off"
              placeholder="Pesquisar"
              aria-label="Pesquisar obras"
              @input="debouncedSearchFilter"
              @focus="isSearchFocused = true"
              @blur="hideSearchSuggestions"
            />
          </form>
          <ul v-if="isSearchFocused && filteredResults.length" class="header-search__suggestions" role="listbox">
            <li v-for="item in filteredResults" :key="item.id">
              <a class="header-search__suggestion" :href="projectPath(item)" @click="clearSearch">
                <img :src="item.project_thumb" :alt="item.name" />
                <span>{{ item.name }}</span>
              </a>
            </li>
          </ul>
        </div>

        <!-- Notificações -->
        <v-btn icon class="header-notifications" to="/notifications" aria-label="Notificações">
          <v-badge
            :value="notifications.length > 0"
            :content="notifications.length"
            color="var(--zinnes-primary)"
            overlap
          >
            <v-icon>mdi-bell-outline</v-icon>
          </v-badge>
        </v-btn>

        <!-- Avatar com Menu Dropdown -->
        <v-menu v-if="isAuthenticated" offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-avatar size="40">
                <v-img :src="profilePhoto" alt="Avatar"></v-img>
              </v-avatar>
            </v-btn>
          </template>

          <v-list class="profile-menu">
            <v-list-item v-for="item in menuItems" :key="item.title"
             @click="handleMenuClick(item)"
              :class="{ 'disabled-menu-item': !isItemEnabled(item) }">
              <v-list-item-icon>
                <v-icon color="var(--zinnes-primary)">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-menu>

        <template v-else>
          <v-btn class="ml-3 zinnes-primary-btn header-login" rounded large to="/login">Entrar</v-btn>
        </template>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import NotificationService from "@/server/NotificationService";
import { getSearchProjects } from "@/server/workService";
import { logout } from "@/server/authServe";
import { projectPath } from "@/utils/projectRoutes";
import { normalizeSearchResults, pickArray } from "@/utils/homeProjectNormalizers";

export default {
  name: "HeaderComponent",
  data() {
    return {
      isAuthenticated: false,
      user: null,
      profilePhoto: "",
      searchQuery: "",
      isSearchFocused: false,
      searchDebounceTimer: null,
      searchBlurTimer: null,
      service: new NotificationService(),
      notifications: [],
      menuItems: [
        { title: "Perfil", icon: "mdi-account", route: "/dashboard/user-profiler" },
        { title: "Painel", icon: "mdi-view-dashboard", route: "/dashboard/painel", },
        { title: "Publicar", icon: "mdi-upload", route: "/dashboard/publicar-obra" },
        { title: "Series", icon: "mdi-book-multiple", route: "/series" },
        { title: "Configuração", icon: "mdi-cog", route: "/dashboard/configuracao" },
        { title: "Sair", icon: "mdi-logout", route: "/login" },
      ],
      filteredResults: [],
      intervalo: null,
      isAuthor: false,
      isAdmin: false
    };
  },
  mounted() {
    this.setUserAccess();
    this.checkAuthentication();
    this.getNotification();
    this.intervalo = setInterval(this.getNotification, 100000);

  },
  methods: {
    async handleMenuClick(item) {
      if (!this.isItemEnabled(item)) return;

      if (item.title === "Sair") {
        await logout();
        this.$router.push("/login");
        return;
      }

      if (item.route) {
        this.navigateTo(item.route);
      }
    },
    projectPath,
    isItemEnabled(item) {
      if (item.title === 'Painel' || item.title === 'Publicar') {
        return this.isAuthor || this.isAdmin; // Só ativa se o usuário for um autor
      }
      return true; // Outros itens sempre estão habilitados
    },
    setUserAccess() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        this.isAdmin = user.level === 'GM Guild Master';
        this.isAuthor = user.level === 'OA Administrador';
      }
    },
    debouncedSearchFilter() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);

      this.searchDebounceTimer = setTimeout(() => {
        this.searchFilter(this.searchQuery);
      }, 250);
    },
    async searchFilter(value) {
      const query = String(value || "").trim();
      if (query.length < 2) {
        this.filteredResults = [];
        return;
      }

      try {
        const results = await getSearchProjects({ name: query });
        this.filteredResults = normalizeSearchResults(pickArray(results, "data"));
      } catch (error) {
        console.error("Erro ao buscar projetos:", error);
        this.filteredResults = [];
      }
    },
    executeSearch() {
      const query = String(this.searchQuery || "").trim();
      if (!query) return;
      this.$router.push({ path: '/series', query: { q: query } })
      this.clearSearch();
    },
    clearSearch() {
      this.searchQuery = "";
      this.filteredResults = [];
      this.isSearchFocused = false;
    },
    hideSearchSuggestions() {
      if (this.searchBlurTimer) clearTimeout(this.searchBlurTimer);
      this.searchBlurTimer = setTimeout(() => {
        this.isSearchFocused = false;
      }, 140);
    },
    async getNotification() {
      const auth = JSON.parse(localStorage.getItem("auth"));
      const user = JSON.parse(localStorage.getItem("user"));
      if (auth && user) {
        let res = await this.service.list({ news: true });
        this.notifications = res ? res : [];
      }
    },
    checkAuthentication() {
      const auth = JSON.parse(localStorage.getItem("auth"));
      const user = JSON.parse(localStorage.getItem("user"));

      if (auth && user) {
        this.isAuthenticated = true;
        this.user = user;
        this.profilePhoto = user.profile_photo
          ? user.profile_photo
          : "https://i.pinimg.com/564x/d2/98/4e/d2984ec4b65a8568eab3dc2b640fc58e.jpg";
      }
    },
    navigateTo(route) {
      this.$router.push(route);
    },
  },
  beforeDestroy() {
    if (this.intervalo) clearInterval(this.intervalo);
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
    if (this.searchBlurTimer) clearTimeout(this.searchBlurTimer);
  },
};
</script>



<style scoped>
.disabled-menu-item {
  pointer-events: none;
  opacity: 0.5;
}

.v-app-bar {
  z-index: 1000 !important;
}

.v-app-bar ::v-deep .v-toolbar__content {
  z-index: 1001 !important;
}

.app-bar-content {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1002;
}

.nav {
  display: flex;
  gap: 12px;
  align-items: center;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  z-index: 1002;
}

.nav-button {
  position: relative;
  z-index: 1002;
}

.container-btns {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 1002;
}

.container-btns .v-btn {
  position: relative;
  z-index: 1002;
}

.profile-menu {
  background: black;
  min-width: 200px;
}

.v-list-item {
  color: white !important;
  font-size: 16px;
  transition: background 0.3s;
}

.v-list-item:hover {
  background: #333;
}

.v-list-item-icon {
  color: white;
}

.app-bar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.nav {
  display: flex;
  gap: 12px;
  align-items: center;
}

.nav-button {
  transition: all 0.3s ease;
}

.nav-button .v-icon {
  font-size: 28px !important;
  color: white;
  transition: color 0.3s ease;
  z-index: 1003;
  position: relative;
}

.nav-button:hover .v-icon,
.nav-button.v-btn--active .v-icon {
  color: #FFD700 !important;
}

.nav-icon-img {
  width: 35.28px;
  height: 35.28px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  transition: filter 0.3s ease;
  z-index: 1003;
  position: relative;
}

/* Ícone Zinnes maior (25%) */
.nav-button--zinnes .nav-icon-img {
  width: 42.8px;
  height: 42.8px;
}

/* Dourado nos PNGs quando ativo/hover */
.nav-button:hover .nav-icon-img,
.nav-button.v-btn--active .nav-icon-img {
  filter: brightness(0) saturate(100%) invert(66%) sepia(99%) saturate(1500%) hue-rotate(0deg) brightness(104%) contrast(101%);
}

.nav-button--zinnes:hover .nav-icon-img,
.nav-button--zinnes.v-btn--active .nav-icon-img {
  filter: brightness(0) saturate(100%) invert(66%) sepia(99%) saturate(1500%) hue-rotate(0deg) brightness(104%) contrast(101%);
}

.container-btns {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-search {
  position: relative;
  width: clamp(180px, 18vw, 260px);
  z-index: 1004;
}

.header-search__form {
  align-items: center;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 999px;
  display: flex;
  gap: 6px;
  min-height: 34px;
  padding: 0 12px;
}

.header-search__icon {
  color: var(--zinnes-primary) !important;
  font-size: 18px !important;
}

.header-search__input {
  background: transparent;
  border: 0;
  color: #160d1f;
  flex: 1;
  font-size: 13px;
  font-weight: 700;
  min-width: 0;
  outline: none;
}

.header-search__input::placeholder {
  color: rgba(22, 13, 31, 0.58);
}

.header-search__suggestions {
  background: rgba(13, 7, 18, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 14px;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.38);
  left: 0;
  list-style: none;
  margin: 8px 0 0;
  max-height: 300px;
  overflow: auto;
  padding: 8px;
  position: absolute;
  right: 0;
  top: 100%;
}

.header-search__suggestion {
  align-items: center;
  border-radius: 10px;
  color: #ffffff;
  display: flex;
  gap: 10px;
  padding: 8px;
  text-decoration: none;
}

.header-search__suggestion:hover {
  background: rgba(255, 255, 255, 0.08);
}

.header-search__suggestion img {
  border-radius: 4px;
  height: 48px;
  object-fit: cover;
  width: 36px;
}

.header-search__suggestion span {
  display: -webkit-box;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.logo-image {
  z-index: 1003;
  position: relative;
}

@media (max-width: 1024px) {
  .nav {
    gap: 10px;
  }

  .container-btns {
    gap: 12px;
  }

  .header-search {
    width: clamp(150px, 24vw, 220px);
  }
}

@media (max-width: 767px) {
  .v-app-bar ::v-deep .v-toolbar__content {
    height: 100% !important;
    padding-left: 12px;
    padding-right: 12px;
  }

  .app-bar-content {
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;
    height: 100%;
    justify-content: space-between;
    min-width: 0;
  }

  .app-bar-content > .v-toolbar__title {
    flex: 0 0 72px;
    height: 24px;
    line-height: 24px;
    overflow: visible;
  }

  .nav {
    display: none;
  }

  .container-btns {
    flex: 1 1 0;
    gap: 8px;
    justify-content: flex-end;
    min-width: 0;
    width: auto;
  }

  .header-search {
    flex: 0 1 168px;
    max-width: 168px;
    min-width: 0;
    width: auto;
  }

  .logo-image {
    height: 24px !important;
    width: 72px;
  }

  .container-btns > .v-btn {
    flex: 0 0 32px;
    height: 32px !important;
    min-width: 32px !important;
    width: 32px !important;
  }

  .container-btns > .header-notifications.v-btn {
    margin-right: 8px;
  }

  .container-btns ::v-deep .v-avatar {
    height: 32px !important;
    min-width: 32px !important;
    width: 32px !important;
  }

  .container-btns > .header-login.v-btn {
    flex: 0 0 76px;
    height: 32px !important;
    margin-left: 0 !important;
    min-width: 76px !important;
    padding: 0 14px !important;
    width: 76px !important;
  }
}

@media (max-width: 420px) {
  .v-icon {
    font-size: 14px !important;
  }

  .v-btn {
    font-size: 10px;
  }

  .header-search {
    min-width: 0;
  }

  .header-search__form {
    min-height: 30px;
    padding: 0 9px;
  }

  .header-search__input {
    font-size: 12px;
  }

}
</style>
